import { useEffect } from "react";

export const useScrollToLastMessage = (
  containerRef,
  deps = [],
  itemSelector = ".message-wrapper"
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const mesages = container.querySelectorAll(itemSelector);
    if (!mesages.length) return;

    const lastMesage = mesages[mesages.length - 1];

    const scrollPosition =
      lastMesage.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop;

    container.scrollTo({
      top: scrollPosition,
      behavior: "smooth"
    });
  }, deps);
};
